import React, { Fragment } from "react";

const FooterBottom = () => (
  <Fragment>
    <div className="footer__stripes">
      <span /> <span /> <span /> <span /> <span />
    </div>
    <div className="footer__corporate">
      <div className="footer__container">
        <div className="footer__row">
          <div className="footer__column">
            <h4 className="footer__title footer__title--orange">Kurumsal</h4>
            <ul className="footer__list">
              <li className="footer__list-item">
                <a href="https://kurumsal.hepsiburada.com" rel="nofollow">
                  Hakkımızda
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://kurumsal.hepsiburada.com/tr/hepsiburada-dunyasi"
                  rel="nofollow"
                >
                  İş Ortaklarımız
                </a>
              </li>
              <li className="footer__list-item">
                <a href="https://investors.hepsiburada.com" rel="nofollow">
                  Yatırımcı ilişkileri
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.hepsiburada.com/cozummerkezi"
                  rel="nofollow"
                >
                  Müşteri Hizmetleri
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://kurumsal.hepsiburada.com/tr/kariyer"
                  rel="nofollow"
                >
                  Kariyer
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.hepsiburada.com/kisisel-verilerin-korunmasi"
                  rel="nofollow"
                >
                  Kişisel Verilerin Korunması
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.hepsiburada.com/staticpage/662670399601409"
                  rel="nofollow"
                >
                  Bilgi Güvenliği Politikası
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.hepsiburada.com/guvenli-alisveris"
                  rel="nofollow"
                >
                  Güvenli Alışveriş Kılavuzu
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.hepsiburada.com/is-sagligi-ve-guvenligi-cevre-politikamiz"
                  rel="nofollow"
                >
                  İş Sağlığı ve Güvenliği Çevre Politikamız
                </a>
              </li>
              <li className="footer__list-item">
                <a href="https://www.hepsiburada.com/iletisim" rel="nofollow">
                  İletişim
                </a>
              </li>
            </ul>
          </div>
          <div className="footer__column">
            <h4 className="footer__title footer__title--orange">Hepsiburada</h4>
            <ul className="footer__list">
              <li className="footer__list-item">
                <a
                  href="https://www.hepsiburada.com/nasil-online-satis-yapilir"
                  rel="nofollow"
                >
                  Satıcı Olmak İstiyorum
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.hepsipay.com/?utm_source=hepsiburada&utm_medium=affiliate&utm_campaign=footer_link"
                  rel="nofollow"
                >
                  Hepsipay İşyeri Olmak İstiyorum
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.hepsiburada.com/staticPage/12027"
                  rel="nofollow"
                >
                  Tedarikçi Davranış Kuralları
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.hepsiburada.com/kampanyalar/girisimci-kadinlar"
                  rel="nofollow"
                >
                  Girişimci Kadınlara Teknoloji Gücü
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://hbmarketplace.secure.force.com/HepsimatApplicationForm"
                  rel="nofollow"
                >
                  Teslimat Noktası Olmak İstiyorum
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.hepsiburada.com/odeme-secenekleri"
                  rel="nofollow"
                >
                  Ödeme Seçenekleri
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.hepsiburada.com/banka-kampanyalari"
                  rel="nofollow"
                >
                  Banka Kampanyaları
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.hepsiburada.com/islem-rehberi"
                  rel="nofollow"
                >
                  İşlem Rehberi
                </a>
              </li>
            </ul>
          </div>
          <div className="footer__column">
            <h4 className="footer__title footer__title--orange">
              Bizi Takip Edin
            </h4>
            <ul className="footer__list">
              <li className="footer__list-item">
                <a
                  href="http://instagram.com/hepsiburada"
                  rel="nofollow"
                  className="footer__link--social"
                  target="_blank"
                >
                  <span className="footer__social-icon">
                    <img
                      loading="lazy"
                      src="https://images.hepsiburada.net/assets/footer/instagram.svg"
                    />
                  </span>
                  <span>Instagram</span>
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.youtube.com/hepsiburada"
                  rel="nofollow"
                  className="footer__link--social"
                  target="_blank"
                >
                  <span className="footer__social-icon">
                    <img
                      loading="lazy"
                      src="https://images.hepsiburada.net/assets/footer/youtube.svg"
                    />
                  </span>
                  <span>Youtube</span>
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.tiktok.com/@hepsiburada?lang=en"
                  rel="nofollow"
                  className="footer__link--social"
                  target="_blank"
                >
                  <span className="footer__social-icon">
                    <img
                      loading="lazy"
                      src="https://images.hepsiburada.net/assets/footer/tiktok.svg"
                    />
                  </span>
                  <span>TikTok</span>
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.facebook.com/Hepsiburada"
                  rel="nofollow"
                  className="footer__link--social"
                  target="_blank"
                >
                  <span className="footer__social-icon">
                    <img
                      loading="lazy"
                      src="https://images.hepsiburada.net/assets/footer/facebook.svg"
                    />
                  </span>
                  <span>Facebook</span>
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://twitter.com/hepsiburada"
                  rel="nofollow"
                  className="footer__link--social"
                  target="_blank"
                >
                  <span className="footer__social-icon">
                    <img
                      loading="lazy"
                      src="https://images.hepsiburada.net/assets/footer/x.svg"
                    />
                  </span>
                  <span>X</span>
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="https://www.linkedin.com/company/hepsiburada"
                  rel="nofollow"
                  className="footer__link--social"
                  target="_blank"
                >
                  <span className="footer__social-icon">
                    <img
                      loading="lazy"
                      src="https://images.hepsiburada.net/assets/footer/linkedin.svg"
                    />
                  </span>
                  <span>Linkedin</span>
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  href="http://www.pinterest.com/hepsiburada"
                  rel="nofollow"
                  className="footer__link--social"
                  target="_blank"
                >
                  <span className="footer__social-icon">
                    <img
                      loading="lazy"
                      src="https://images.hepsiburada.net/assets/footer/pinterest.svg"
                    />
                  </span>
                  <span>Pinterest</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="footer__column">
            <h4 className="footer__title footer__title--orange">
              Mobil Uygulamalar
            </h4>
            <a
              href="http://itunes.apple.com/qa/app/hepsiburada/id481035064?mt=8&_ga=1.233749270.943623564.1417507753"
              rel="nofollow"
              className="footer__box footer__box--app"
              target="_blank"
            >
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/app-store.svg"
              />
              <p>
                <strong>APP STORE'dan</strong> <span>İNDİREBİLİRSİNİZ</span>
              </p>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.pozitron.hepsiburada&feature=search_result#?t=W251bGwsMSwxLDEsImNvbS5wb3ppdHJvbi5oZXBzaWJ1cmFkYSJd"
              rel="nofollow"
              className="footer__box footer__box--app"
              target="_blank"
            >
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/google-play.svg"
              />
              <p>
                <strong>GOOGLE PLAY'dan</strong> <span>İNDİREBİLİRSİNİZ</span>
              </p>
            </a>
            <a
              href="https://hps.im/1t9"
              rel="nofollow"
              className="footer__box footer__box--app"
              target="_blank"
            >
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/huawei-app-gallery.svg"
              />
              <p>
                <strong>APP GALLERY'den</strong> <span>İNDİREBİLİRSİNİZ</span>
              </p>
            </a>
          </div>
          <div className="footer__column footer__column--center">
            <h4 className="footer__title footer__title--orange">
              Aklınıza takılan bir soru mu var?
            </h4>
            <a
              href="https://www.hepsiburada.com/cozummerkezi"
              rel="nofollow"
              className="footer__box"
            >
              Çözüm Merkezine bağlanın
            </a>
            <div className="footer__or-separator">
              <span>veya</span>
            </div>
            <p className="footer__solution-text">Çağrı Merkezimizi arayın</p>
            <a
              href="tel:0850-252-4000"
              className="footer__solution-center-phone"
            >
              0850 252 40 00
            </a>
            <a
              href="https://web.whatsapp.com/send?phone=908502524000"
              rel="nofollow"
              className="footer__whatsapp"
              target="_blank"
            >
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/whatsapp.svg"
                className="footer__whatsapp-icon"
              />
              <span>WhatsApp Destek</span>
            </a>
          </div>
        </div>
        <div className="footer__row footer__row--between">
          <div className="footer__column">
            <div className="footer__bank-cards">
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/bonus-card.svg"
                width={76}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/maximum.svg"
                width={62}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/world.svg"
                width={62}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/ziraat.svg"
                width={58}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/card-finans.svg"
                width={64}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/axess.svg"
                width={43}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/kuveyt-turk.svg"
                width={76}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/hsbc.svg"
                width={134}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/union-pay.svg"
                width={26}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/paraf.svg"
                width={32}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/visa.svg"
                width={51}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/master-card.svg"
                width={31}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/american-express.svg"
                width={27}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/troy.svg"
                width={42}
              />
            </div>
          </div>
          <div className="footer__column">
            <div className="footer__icons">
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/guvenli-alisveris-icon.webp"
                width={112}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/pci-icon.webp"
                width={60}
              />
              <img
                loading="lazy"
                src="https://images.hepsiburada.net/assets/footer/iso-icon.webp"
                width={32}
              />
              <a
                href="https://www.guvendamgasi.org.tr/firmadetay.php?Guid=5456fc2e-7e4c-11ea-8718-48df373f4850"
                rel="nofollow"
                target="_blank"
              >
                <img
                  loading="lazy"
                  src="https://images.hepsiburada.net/assets/footer/guven-damgasi-icon.webp"
                  width={32}
                />
              </a>
              <a
                href="https://etbis.eticaret.gov.tr/sitedogrulama/8196FDEF645148A88D019AF721915768"
                rel="nofollow"
                target="_blank"
              >
                <img
                  loading="lazy"
                  src="https://images.hepsiburada.net/assets/footer/etbis-icon.webp"
                  width={28}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="footer__bottom">
      <div className="footer__container">
        <div className="footer__row">
          <div className="footer__column">
            <p className="footer__copyright-text">
              © Copyright 1998 - 2024 D-MARKET
              Elektronik Hizmetler Tic. A.Ş. Her Hakkı Saklıdır.
            </p>
            <p className="footer__brand-text">
              Hepsiburada.com
            </p>
          </div>
          <div className="footer__columns">
            <div className="footer__copyright-icons">
              <a> 
                <img
                  loading="lazy"
                  src="https://images.hepsiburada.net/assets/footer/kaspi-logo.png"
                  width={65}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Fragment>
)

export default FooterBottom
